@import '~style-sheet-helpers/core.less';
@import (reference) '../../../constants/spacing.module.less';

.panel {
  border: 1px solid var(--grey-300);
  width: 260px;
  height: fit-content;
}

.panel-header {
  background-color: var(--grey-200);
  border-bottom: 1px solid var(--grey-300);
  font-weight: 600;
  font-size: 14px;
  color: var(--grey-800);
  border-radius: 4px 4px 0 0;
  padding: @space-4 @space-8;
}

.properties {
  padding: @space-16;
}

.property-group {
  display: flex;
  align-items: center;
  flex-direction: row;
  padding: 2px @space-0;
}

.property-label {
  flex: 1;
  margin: @space-4 @space-0 @space-8 @space-0;
  color: var(--grey-800);
  font-size: 14px;
  font-weight: 500;
}

.property-input {
  flex: 1;
}

.form-group {
  margin-bottom: @space-8;
  display: flex;
  align-items: center;
}

.delete-button {
  margin-top: @space-8;
}
